var map = {
	"./bunny-lines/1.svg": "d23a",
	"./bunny-lines/2.svg": "5ca5",
	"./bunny-lines/3.svg": "9142",
	"./chin-crease/1.svg": "dad7",
	"./chin-crease/2.svg": "a5c5",
	"./chin-crease/3.svg": "a254",
	"./crows-feet/1.svg": "611b",
	"./crows-feet/2.svg": "49f5",
	"./crows-feet/3.svg": "3392",
	"./forehead-lines/1.svg": "687e",
	"./forehead-lines/2.svg": "537a",
	"./forehead-lines/3.svg": "b71e",
	"./frown-lines/1.svg": "22bb",
	"./frown-lines/2.svg": "5a6e",
	"./frown-lines/3.svg": "a3d3",
	"./marionette-lines/1.svg": "329f",
	"./marionette-lines/2.svg": "dadf",
	"./marionette-lines/3.svg": "c0a6",
	"./mouth-frown/1.svg": "c844",
	"./mouth-frown/2.svg": "0fc1",
	"./mouth-frown/3.svg": "8b36",
	"./nasolabial-folds/1.svg": "95a3c",
	"./nasolabial-folds/2.svg": "0792",
	"./nasolabial-folds/3.svg": "ea6d",
	"./neck/1.svg": "163f",
	"./neck/2.svg": "e1a0",
	"./neck/3.svg": "e622",
	"./tear-troughs/1.svg": "6a91",
	"./tear-troughs/2.svg": "81d6b",
	"./tear-troughs/3.svg": "0676",
	"./vertical-lip-lines/1.svg": "a066",
	"./vertical-lip-lines/2.svg": "4ccb",
	"./vertical-lip-lines/3.svg": "6073"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c1c95";